var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:_vm.orientation == 0 && _vm.isMobile ? 'custom-toast-portrait' : 'custom-toast'},[_c('div',{staticClass:"custom-toast-box"},[_c('span',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }